module.exports = __webpack_public_path__ + "static/img/18.e3ea0f1a.png";